export const MIN_EDITOR_WIDTH_PX = 350;
export const MAX_EDITOR_WIDTH_PX = 750;

export const PRINT_BACKGROUND_COLOR = '#ffffff';
